import React, { useEffect, useState } from 'react';
import { useUser } from '../context';

import Navbar from '../Components/Navbar/Navbar';
import Home from '../Pages/Home/Home';
import Interior from '../Pages/Interior/Interior';
import Cars from '../Pages/Cars/Cars';
import GetQuote from '../Pages/GetQuote/GetQuote';
import Services from '../Pages/Services/Services';
import WhyUs from '../Pages/WhyUs/WhyUs';
import Articles from '../Pages/Articles/Articles';
import Footer from '../Components/Footer/Footer';

import Cross from '../assets/cross.svg';
import Whatsapp from '../assets/whatsapp.svg';
import Angle from '../assets/angle.svg';


const UnAuthorized = () => {

    const { sideMenu, setSideMenu, isScrolled, whatsappApi } = useUser();

    useEffect(() => {
        console.log('Whatsapp', whatsappApi);
    }, [whatsappApi])
    const [popupClosing, setPopupClosing] = useState(false);

    const scrollToSection = (id) => {
        const element = document.getElementById(id);
        if (element) {
            const offset = window.innerHeight * 0.1;
            const elementPosition = element.getBoundingClientRect().top + window.scrollY;
            const targetPosition = elementPosition - offset;

            window.scrollTo({
                top: targetPosition,
                behavior: 'smooth',
            });
        }
    };


    return (
        <div className="w-full h-[100vh] relative">

            {/* Whatsapp Button */}
            <div
                onClick={() => {
                    window.open(whatsappApi, "_blank");
                }}
                className='animate-fadeInOutBounce hover:animate-none hover:cursor-pointer fixed rounded-full bottom-5 left-5 z-30 bg-[#25D366] p-3 flex justify-center items-center transform transition-transform duration-200 hover:translate-y-[-4px]'>
                <img src={Whatsapp} alt="whatsapp" className='invert' width={25} />
            </div>

            {isScrolled && (
                <div
                    onClick={() => {
                        window.scrollTo({
                            top: 0,
                            behavior: 'smooth',
                        });
                    }}
                    className='fixed rounded-full bottom-5 right-5 z-30 bg-customYellow p-2 flex justify-center items-center transform transition-transform duration-200 hover:translate-y-[-4px]'>
                    <img src={Angle} alt="angle" width={25} className='invert' />
                </div>
            )}

            {sideMenu && (
                <div
                    style={{
                        animation: `${popupClosing ? "fadeOut" : "fadeIn"
                            } 0.5s ease-in-out forwards`,
                    }}
                    className='fixed z-50 w-full h-full bg-black bg-opacity-50 backdrop-blur-sm flex justify-end items-center'>
                    <div
                        style={{
                            animation: `${popupClosing ? "closePopup" : "openPopup"
                                } 0.5s ease-in-out forwards`,
                        }}
                        className="side-box w-[100%] lg:w-[30%] h-full bg-black bg-opacity-80 flex flex-col items-center transition-transform duration-300 ease-in-out"
                    >
                        <div className='w-full h-[20vh] flex justify-end items-center p-10'>
                            <button
                                onClick={() => {
                                    setPopupClosing(true);
                                    setTimeout(() => {
                                        setSideMenu(false);
                                        setPopupClosing(false);
                                    }, 500);
                                }}
                                className='bg-customYellow p-2 rounded-full transform transition-transform duration-200 hover:translate-y-[-4px]'
                            >
                                <img src={Cross} alt="cross" className='invert' width={30} />
                            </button>
                        </div>
                        <div className='w-full h-full'>
                            <ul className='flex flex-col justify-center items-start px-10 text-2xl font-bold text-white gap-5'>
                                <li
                                    onClick={() => {
                                        setPopupClosing(true);
                                        setTimeout(() => {
                                            setSideMenu(false);
                                            setPopupClosing(false);
                                        }, 500);
                                        scrollToSection('cars');
                                    }}
                                    className='hover:text-customYellow hover:cursor-pointer'
                                >
                                    VEHICLES
                                </li>
                                <li
                                    onClick={() => {
                                        setPopupClosing(true);
                                        setTimeout(() => {
                                            setSideMenu(false);
                                            setPopupClosing(false);
                                        }, 500);
                                        scrollToSection('services');
                                    }}
                                    className='hover:text-customYellow hover:cursor-pointer'
                                >
                                    SERVICES
                                </li>
                                <li
                                    onClick={() => {
                                        setPopupClosing(true);
                                        setTimeout(() => {
                                            setSideMenu(false);
                                            setPopupClosing(false);
                                        }, 500);
                                        scrollToSection('home');
                                    }}
                                    className='hover:text-customYellow hover:cursor-pointer'
                                >
                                    HOME
                                </li>
                            </ul>
                        </div>

                        {/* social links */}
                        <div className='w-full h-full my-20'>
                            <ul className='flex justify-start items-center gap-5 px-10'>
                                <li
                                    onClick={() => {
                                        window.open(whatsappApi, "_blank");
                                    }}
                                    className='hover:cursor-pointer hover:-translate-y-[3px] hover:scale-125 transition-transform duration-200 ease-out'
                                >
                                    <img src={Whatsapp} alt="whatsapp" width={35} className='invert' />
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            )}

            {/* Navbar */}
            <div id='navbar' className='w-full h-[15vh] fixed top-0 z-30'>
                <Navbar onNavigate={scrollToSection} />
            </div>

            {/* Home */}
            <section id='home' className='w-full h-[100vh] bg-white'>
                <Home />
            </section>

            {/* Cars */}
            <section id='cars' className='w-full h-[150vh] lg:h-[120vh] pt-20 pb-10 flex justify-center items-center'>
                <Cars />
            </section>

            {/* Interior */}
            <section id='interior' className='w-full h-[80vh] lg:h-[80vh] flex justify-center items-center'>
                <Interior />
            </section>

            {/* Get Quote */}
            {/*
            <section id='getQuote' className='w-full h-[100vh] lg-[80vh] pt-10'>
                <GetQuote />
            </section>
            */}

            <section id='services' className='w-full h-[280vh] lg:h-[200vh] flex justify-center items-center'>
                <Services />
            </section>

            {/* Why Choose Us */}
            <section id='whyUs' className='w-full h-[180vh] lg:h-[100vh] bg-customYellow'>
                <WhyUs />
            </section>

            {/* Articles */}
            {/*
            <section id='articles' className='w-full h-[300vh] lg:h-[120vh] pt-10'>
                <Articles />
            </section>
            */}

            {/* Footer */}
            <div id='footer' className='relative w-full h-[10vh] bg-customYellow'>
                <div className='w-full h-full absolute z-0 bg-black opacity-30'></div>
                <div className='w-full h-full absolute z-10'>
                    <Footer />
                </div>
            </div>
        </div>
    );
};

export default UnAuthorized;
